import { connect } from 'react-redux';

import LogoutLink from './LogoutLink';
import { logout } from '../../../actions/auth/actionCreators';


const mapStateToProps = ({ profile }) => ({
  email: profile.email
});

const mapDispatchToProps = dispatch => ({
  onClick: () => {
    dispatch(logout());
  }
});

const LogoutLinkContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LogoutLink);

export default LogoutLinkContainer;


// WEBPACK FOOTER //
// src/components/login/LogoutLink/LogoutLinkContainer.js